<template>
  <div id="myCalendar">
    <el-card
      shadow="hover"
      class="mainCard clear-card"
    >
      <div class="header">
        <div class="title defaultCursor">
          {{ $t('coach.myCalendar.title') }}
        </div>
        <div class="action">
          <el-button
            type="text"
            @click="$emit('update:show', !show)"
          >
            {{ show ? $t('common.hide') : $t('common.view') }}
          </el-button>
        </div>
      </div>

      <el-collapse-transition>
        <div
          v-if="show"
          class="content"
        >
          <div style="margin: 10px 5px 20px;">
            {{ $t('coach.myCalendar.desc') }}
          </div>

          <el-row
            :gutter="15"
          >
            <el-col
              :span="responsiveRow.one"
              class="left"
            >
              <el-col :span="responsiveCol">
                <el-button
                  :type="view === 'month' ? 'none' : 'primary'"
                  round
                  @click="view = 'month'"
                >
                  {{ $t('coach.myCalendar.monthly') }}
                </el-button>
              </el-col>

              <el-col :span="responsiveCol">
                <el-button
                  :type="view === 'week' ? 'none' : 'primary'"
                  round
                  @click="view = 'week'"
                >
                  {{ $t('coach.myCalendar.weekly') }}
                </el-button>
              </el-col>

              <el-col :span="responsiveCol">
                <el-button
                  :type="view === 'list' ? 'none' : 'primary'"
                  round
                  @click="view = 'list'"
                >
                  {{ $t('coach.myCalendar.listView') }}
                </el-button>
              </el-col>
            </el-col>
            <el-col
              :span="responsiveRow.two"
              class="right"
            >
              <CalendarWidget
                ref="calendarWidget"
                v-loading="loadArr.length"
                :view="view"
                :calendar-events="calendarEvents"
                :active-start.sync="activeStart"
                :active-end.sync="activeEnd"
                :placed-date.sync="placedDate"
                @datesRender="datesRender"
              />
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import CalendarWidget from './fullCalendar/CalendarWidget.vue';

export default {
  components: {
    CalendarWidget,
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // show: false,
      view: 'month',
      calendarEvents: [],
      activeStart: '',
      activeEnd: '',
      loadArr: [],
      placedDate: null,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    responsiveRow() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 5;
        col.two = 19;
      }
      return col;
    },
    responsiveCol() {
      let col = 24;
      if (this.$mq === 'tablet') {
        col = 8;
      }
      return col;
    },
    responseDate() {
      return this.$route.params.date ? this.$route.params.date : null;
    },
  },

  watch: {
    responseDate(newDate) {
      if (newDate) {
        this.view = 'list';
        this.placedDate = newDate;
      }
    },

    user: {
      immediate: true,
      deep: true,
      handler() {
        this.forceRoleCheck();
      },
    },
  },

  async mounted() {
    await this.forceRoleCheck();
    if (this.$route.params.date) {
      this.view = 'list';
      this.placedDate = this.$route.params.date;
    }
  },

  methods: {
    forceRoleCheck() {
      if (this.user.user.role_type !== 'coach') {
        this.$router.push({ name: 'dashboard' });
      }
    },

    datesRender({ startDate, endDate }) {
      this.getEvents(startDate, endDate);
    },

    async getEvents(startDate, endDate) {
      try {
        // Set length for multiple api request
        this.loadArr.push('l');
        const response = await api.getCoachCalendar({
          start_date: startDate,
          end_date: endDate,
        });
        this.calendarEvents = this.formatEventsList(response.data);
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        // Delete one item in array
        this.loadArr.pop();
      }
    },

    formatEventsList(events) {
      const formattedEvents = events.map((el) => {
        const session = el.session_id === 'on_boarding'
          ? 'Introductory session'
          : `Session ${el.session_id.split('_')[1]}`;

        const event = {
          title: `${el.leader} - ${session}`,
          start: el.start_time,
          end: el.end_time,
          sessionId: el.session_id,
          session,
          leaderUuid: el.leader_uuid,
        };

        return event;
      });

      return formattedEvents;
    },
  },
};
</script>

<style lang="scss" scoped>
#myCalendar {
  .header {
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: bold;
    }

    .action {
      .el-button {
        color: var(--themeFontColor);
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .content {
    text-align: left;
    padding-top: 20px;

    .el-row {
      .left {
        & > div {
          margin-bottom: 15px;
        }

        .el-button {
          width: 100%;
          padding: 13px 0;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
